import Card, { CardHeader, CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import { Tabs, TabList, Tab, TabPanel } from '@/components/ui/Tabs';

export default function AdminSettingsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">Settings</h1>
        <p className="text-slate-600 dark:text-slate-300 mt-1">Configure system settings and preferences</p>
      </div>

      <Tabs defaultTab="general">
        <TabList>
          <Tab value="general">General</Tab>
          <Tab value="api">API Keys</Tab>
        </TabList>

        <TabPanel value="general" className="mt-6">
          <Card>
            <CardHeader title="General Settings" />
            <CardBody className="space-y-4">
              <Input label="Application Name" defaultValue="Kampus Unified" />
              <Input label="Default Locale" defaultValue="fr-CA" />
              <Input label="Support Email" defaultValue="support@kampus.com" />
              <div className="pt-4">
                <Button>Save Changes</Button>
              </div>
            </CardBody>
          </Card>
        </TabPanel>

        <TabPanel value="api" className="mt-6">
          <Card>
            <CardHeader title="API Keys" subtitle="Manage API keys for service integrations" />
            <CardBody className="space-y-4">
              <div className="p-4 bg-slate-50 dark:bg-slate-800/60 rounded-xl">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium text-slate-900 dark:text-slate-100">TTS Worker API Key</p>
                    <p className="text-sm text-slate-600 dark:text-slate-300 font-mono">sk-tts-****-****-****-abc123</p>
                  </div>
                  <Button variant="outline" size="sm">Regenerate</Button>
                </div>
              </div>
              <div className="p-4 bg-slate-50 dark:bg-slate-800/60 rounded-xl">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium text-slate-900 dark:text-slate-100">Distribution Worker API Key</p>
                    <p className="text-sm text-slate-600 dark:text-slate-300 font-mono">sk-dist-****-****-****-xyz789</p>
                  </div>
                  <Button variant="outline" size="sm">Regenerate</Button>
                </div>
              </div>
              <Button>Add New API Key</Button>
            </CardBody>
          </Card>
        </TabPanel>

      </Tabs>
    </div>
  );
}

